<template>
  <main-layout
    customControls
    controlsBg="light"
    :hasControlsBar="true"
    :breadcrumb="getBreadcrumb">
    <div slot="custom-controls-top">
      <div class="controls__filters note">
        <health-week-control
          v-model="selectedDay"
          v-on:input="requestDataInEmit"
        />
        <health-explorer-controls-user-select
          v-model="selectedUser"
          v-on:click="checkNutritionalPlanExpiration"
          v-show="!disableUserSelect"
          v-on:hidden="hiddeComp"
        />
      </div>
    </div>
    <div class="container">
      <grid-row class="margin-top-xl" column-align="center">
        <grid-col col-size="4">
          <div id="header">
            <h1 class="header-title">
              <chevron
                @click="$router.push({name: 'NutritionalPlanMenu'})"/>
              {{ $t('health.nutritionalPlan.calendar') }}
            </h1>
            <alert
              v-if="alertVisible"
              :message="alertMessage"
              :type="alertType">
            </alert>
          </div>
        </grid-col>
        <div v-if="hasPlan">
          <form
            v-if="hasPlan && gramsKiloMode"
            v-on:submit.prevent
            v-on:keypress.enter.prevent="onSave"
            v-on:keydown.space.prevent="'false'">
            <grid-col col-size="1">
              <div class="center-vertical variable-input-field submit-buttons align-right">
                <btn-pill
                  :btnText="$t('health.userProfile.update')"
                  v-on:click="onSave"
                  btn-size="m">
                </btn-pill>
              </div>
            </grid-col>
          </form>
        </div>
      </grid-row>
      <div v-if="hasPlan">
        <week-plan-editor-table
          ref="weekTable"
          v-if="gramsKiloMode"
          class="margin-left-m margin-right-m margin-top-l"
          :data="weekPlan"
          v-on:update="updateData"
        />
        <grid-row
          v-else
          class="margin-top-xl" column-align="center">
        <grid-col
          col-size="4">
          <p
          >{{ $t('health.nutritionalPlan.notGramsKiloMode') }}</p>
        </grid-col>
        </grid-row>
      </div>
      <grid-row
        v-else
        class="margin-top-xl" column-align="center">
        <grid-col col-size="4">
          <p
          >{{ $t('health.userProfile.nutritionalPlanExpired') }}</p>
        </grid-col>
      </grid-row>
    </div>
  </main-layout>
</template>

<script>
import MainLayout from '@/layouts/MainLayout';
import HealthExplorerControlsUserSelect from 'BRAND/components/explorer/HealthExplorerControlsUserSelect';
import HealthWeekControl from 'BRAND/components/explorer/HealthWeekControl';
import Chevron from '@/components/shared/Chevron';
import GridRow from '@/components/shared/grid/GridRow';
import GridCol from '@/components/shared/grid/GridCol';
import nutritionApi from 'BRAND/api/nutritionPlan';
import BtnPill from '@/components/shared/buttons/BtnPill';
import Alert from '@/components/shared/alert/Alert';
import WeekPlanEditorTable from 'BRAND/components/nutritionPlan/WeekPlanEditorTable';

export default {
  name: 'NutritionCalendar',
  components: {
    MainLayout,
    HealthExplorerControlsUserSelect,
    HealthWeekControl,
    Chevron,
    GridCol,
    GridRow,
    WeekPlanEditorTable,
    BtnPill,
    Alert
  },
  data () {
    return {
      selectedUser: null,
      hasPlan: false,
      gramsKiloMode: false,
      disableUserSelect: false,
      selectedDay: null,
      mealTypes: [
        'Desayuno',
        'Almuerzo',
        'Comida',
        'Merienda',
        'Cena'
      ],
      weekDays: [
        'sunday',
        'monday',
        'tuesday',
        'wednesday',
        'thursday',
        'friday',
        'saturday'
      ],
      weekPlan: [],
      editedWeekPlan: [],
      /* UI controls */
      alertVisible: false,
      alertMessage: '',
      alertType: '' // error, warning, success'
    };
  },
  watch: {
    selectedUser: {
      handler: function () {
        this.checkNutritionalPlanExpiration();
      }
    },
    selectedDay: {
      handler: function () {
        if (this.hasPlan) {
          this.requestData();
        }
      }
    },
    weekPlan: {
      handler: function () {
        this.editedWeekPlan = this.weekPlan;
      }
    }
  },
  created () {
    this.selectedDay = new Date();
    const daysToSubstract = this.selectedDay.getDay() === 0 ? 7 : this.selectedDay.getDay();
    const newDay = this.selectedDay.getDate() - daysToSubstract + 1;
    this.selectedDay = this.selectedDay.setDate(newDay);
    this.checkNutritionalPlanExpiration();
  },
  computed: {
    getBreadcrumb () {
      return [
        {
          name: this.$t('menu.workspace'),
          link: '/workspace'
        },
        {
          name: this.$t('health.nutritionalPlan.menu'),
          link: '/nutritionalPlan/menu'
        },
        {
          name: this.$t('health.nutritionalPlan.calendar'),
          link: '/calendar',
          disabled: true
        }
      ];
    }
  },
  methods: {
    requestData () {
      nutritionApi.getNutritionPlanMode(this, this.selectedUser).then(data => {
        this.gramsKiloMode = data === 'gramsKilo';
        if (!this.gramsKiloMode) {
          return;
        }
        nutritionApi.getWeekCalendar(this, this.selectedUser, this.selectedDay).then(data => {
          this.weekPlan = [];
          const items = data.items;
          this.mealTypes.forEach((value, index) => {
            const item = items.find(item => item.type === value);
            if (item) {
              const existingWeekItems = item.dateValues;
              let newItem = {
                id: index,
                type: value
              };
              for (let i = 0; i < 7; i++) {
                const weekDate = new Date(this.selectedDay);
                weekDate.setDate(weekDate.getDate() + i);
                const foundItem = existingWeekItems.find(weekItem => {
                  return new Date(weekItem.timestamp).getDate() === weekDate.getDate();
                });
                const weekDayText = this.weekDays[weekDate.getDay()];
                let intensity;
                if (!foundItem) {
                  intensity = 0;
                } else {
                  intensity = foundItem.intensity;
                }
                newItem[weekDayText] = intensity;
              }
              this.weekPlan.push(newItem);
            } else {
              const newItem = {
                id: index,
                type: value,
                monday: 0,
                tuesday: 0,
                wednesday: 0,
                thursday: 0,
                friday: 0,
                saturday: 0,
                sunday: 0
              };
              this.weekPlan.push(newItem);
            }
          });
        });
      });
    },
    onSave () {
      let updateItems = [];
      this.editedWeekPlan.forEach(value => {
        const date = new Date(this.selectedDay);
        const type = value.type;
        const monday = {type: type, intensity: value.monday ? value.monday.id : 0, timestamp: date.getTime()};
        date.setDate(date.getDate() + 1);
        const tuesday = {type: type, intensity: value.tuesday ? value.tuesday.id : 0, timestamp: date.getTime()};
        date.setDate(date.getDate() + 1);
        const wednesday = {type: type, intensity: value.wednesday ? value.wednesday.id : 0, timestamp: date.getTime()};
        date.setDate(date.getDate() + 1);
        const thursday = {type: type, intensity: value.thursday ? value.thursday.id : 0, timestamp: date.getTime()};
        date.setDate(date.getDate() + 1);
        const friday = {type: type, intensity: value.friday ? value.friday.id : 0, timestamp: date.getTime()};
        date.setDate(date.getDate() + 1);
        const saturday = {type: type, intensity: value.saturday ? value.saturday.id : 0, timestamp: date.getTime()};
        date.setDate(date.getDate() + 1);
        const sunday = {type: type, intensity: value.sunday ? value.sunday.id : 0, timestamp: date.getTime()};
        updateItems.push(monday, tuesday, wednesday, thursday, friday, saturday, sunday);
      });
      nutritionApi.updateWeekCalendar(this, this.selectedUser, this.selectedDay, updateItems).then(() => {
        showAlert(this, this.$t('health.nutritionalPlan.successCalendarUpdate'), 'success');
      }).catch(() => {
        showAlert(this, this.$t('health.nutritionalPlan.errorCalendarUpdate'), 'error');
      });
    },
    hiddeComp () {
      this.disableUserSelect = !this.disableUserSelect;
    },
    requestDataInEmit () {
      if (this.disableUserSelect) {
        this.checkNutritionalPlanExpiration();
      }
    },
    checkNutritionalPlanExpiration () {
      if (this.selectedUser) {
        nutritionApi.hasNutritionPlan(this, this.selectedUser).then(data => {
          this.hasPlan = data.body;
          if (this.hasPlan) {
            this.requestData();
          }
        });
      }
    },
    updateData (items) {
      this.editedWeekPlan = items;
    }
  }
};

const showAlert = (context, message, type) => {
  context.alertVisible = true;
  context.alertMessage = message;
  context.alertType = type;
  context.showAlert = true;
  setTimeout(() => {
    context.alertVisible = false;
  }, 3000);
};
</script>

<style lang="scss" scoped>
@import "../../../../stylesheets/variables";

.chart-title {
  display: flex;
  font-size: 1.2rem;
  margin-bottom: $sp-margin-small;
  text-align: center;
  align-items: center
}

.container {
  padding-top: $sp-margin;
  padding-bottom: $sp-margin;
  flex-grow: 1;
  min-height: 100%;
  display: flex;
  flex-direction: column;
}

.header {
  display: flex;
  justify-content: space-between;

  &__title {
    margin-bottom: $sp-margin;
    @media (min-width: $breakpoint) {
      display: flex;
      h1 {
        margin-bottom: 0;
        margin-right: $sp-margin;
        padding-right: $sp-margin;
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/brand/health/layouts/nutritionalPlan/NutritionCalendar.vue